<template>
  <ModalBase class="modal_box is-init">
    <template v-slot:main>
      <Loader/>
    </template>
  </ModalBase>
</template>

<script>
import ModalBase from '@/components/modals/ModalBase'
import Loader from '@/components/loaders/Loader'

export default {
  name: 'ModalLoader',
  components: {
    ModalBase,
    Loader
  }
}
</script>
